import React from 'react'
import { Carousel } from 'element-react'

const CarouselSG = () => {
    return (
        <div className="demo-carousel">
            <Carousel indicatorPosition="outside">
                {[1, 2, 3, 4].map((item, index) => {
                    return (
                        <Carousel.Item key={index}>
                            <h3>{item}</h3>
                        </Carousel.Item>
                    )
                })}
            </Carousel>
        </div>
    )
}

export default CarouselSG
